import { useEffect, useMemo } from 'react'
import { useForm } from 'react-hook-form'
import { normalizeSurveyFilters, SurveyFilters } from '../utils/report-filters'

export const useSurveyFilterForm = (
    filters: SurveyFilters,
    setFilters: (filters: Partial<SurveyFilters>) => void
) => {
    const key = JSON.stringify(normalizeSurveyFilters(filters))
    const values = useMemo(() => JSON.parse(key) as SurveyFilters, [key])
    const { control, reset, watch } = useForm<SurveyFilters>({
        defaultValues: values,
    })

    useEffect(() => reset(values), [values, reset])
    useEffect(() => {
        const subscription = watch((value, event) => {
            if (event.type === 'change') {
                setFilters(
                    normalizeSurveyFilters(value as Partial<SurveyFilters>)
                )
            }
        })
        return () => subscription.unsubscribe()
    }, [watch, setFilters])
    return { control, filters: values }
}
